export default {
  scheme: 'Beladeplan',
  schemeName: 'Name des Beladeplans',
  description: 'Beschreibung',
  images: 'Bilder',
};
